"use client";

import { useConsent } from "@shared/hooks/cookie-consent";
import { useMemo } from "react";
import { ActiveAnalyticsProvider } from "./resolve-provider";

export function AnalyticsScript() {
	const { hasConsent, status } = useConsent();
	if (status === "unknown" || !hasConsent("analytics")) {
		return null;
	}
	return <ActiveAnalyticsProvider.AnalyticsScript />;
}

export function useAnalytics() {
	const { hasConsent } = useConsent();
	const provider = ActiveAnalyticsProvider.useAnalytics();

	return useMemo(
		() => ({
			trackEvent: (event: string, data?: Record<string, unknown>) => {
				if (!hasConsent("analytics")) {
					return;
				}
				provider.trackEvent(event, data);
			},
			capturePageView: (input: { url?: string; title?: string } = {}) => {
				if (!hasConsent("analytics")) {
					return;
				}
				const url =
					input.url ??
					(typeof window !== "undefined"
						? window.location.href
						: undefined);
				if (!url) {
					return;
				}
				if (ActiveAnalyticsProvider.capturePageView) {
					ActiveAnalyticsProvider.capturePageView({
						url,
						title: input.title,
					});
				} else {
					provider.trackEvent("$pageview", {
						$current_url: url,
						...(input.title != null ? { title: input.title } : {}),
					});
				}
			},
			identify: (id: string, props?: Record<string, unknown>) => {
				if (!hasConsent("analytics")) {
					return;
				}
				ActiveAnalyticsProvider.identify?.(id, props);
			},
		}),
		[hasConsent, provider],
	);
}
